import request from "utils/request";
import { baseRequestURL } from "api/BaseAPI";

export function getTenants(accessKey) {
  return request(
    baseRequestURL + "v1/tenants",
    {
      method: "GET",
      headers: { Authorization: "Bearer " + accessKey }
    },
    true
  ).then((response) => response);
}

export function getUsersOfTenant(accessKey, tenantID) {
  return request(
    baseRequestURL + "v1/tenant/" + tenantID + "/users",
    {
      method: "GET",
      headers: { Authorization: "Bearer " + accessKey }
    },
    true
  ).then((response) => response);
}

export function updateTenant(accessKey, tenantID, data) {
  return request(
    baseRequestURL + "v1/tenant/" + tenantID,
    {
      method: "PATCH",
      headers: { Authorization: "Bearer " + accessKey },
      body: JSON.stringify(data)
    },
    true
  ).then((response) => response);
}

export function getTenant(accessKey, tenantId) {
  return request(
    baseRequestURL + "v1/tenant/" + tenantId,
    {
      method: "GET",
      headers: { Authorization: "Bearer " + accessKey }
    },
    true
  ).then((response) => response);
}

export function getUsageReport(tenantId) {
  return request(baseRequestURL + "v1/tenant/" + tenantId + "/usage-report", {
    method: "POST",
    body: JSON.stringify({})
  }).then((response) => response);
}
